import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modalUsers: [],
  statusus: [],
  isInput: false,
  page:0,
  searchTerm: "",
  hasNextPage:true,
  loading: false
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {

    getUserAccessRequests: () => {},
    resetAll: (state, action) => {
      state.page = 0;
      state.modalUsers = [];
      state.statusus = 0;
    },
    setPage: (state, action) => {
      // state.page = 0;
      state.page += 6;
    },
    setUserAccessRequests: (state, action) => {
      let data = action.payload.data
     
      if (action.payload.change) {
        state.hasNextPage = data.length === 12;
        state.modalUsers = data;
        state.page = 0;
      } else {
        if (action.payload.change !== null) {
          state.hasNextPage = data.length === 12;
          state.modalUsers.push(...data); 
        }
      }

    },

    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },

    getUserStatus: () => {},
    setUserStatus: (state, action) => {
      state.statusus = action.payload.data
    },
    putUserAccessRequest: () => {},
    setAfterActionUserData: (state, action) => {
      state.modalUsers = state.modalUsers.filter(item => item.user_id !== action.payload.id)
      state.statusus.pending_count -= 1
    }
    
  },
});

export const {getUserAccessRequests, resetAll,  setInputMode, setPage,  setLoading,setUserAccessRequests, setUserStatus, getUserStatus ,
  putUserAccessRequest, setAfterActionUserData} = userDataSlice.actions;
export default userDataSlice.reducer;